import { Component, Input } from '@angular/core';

@Component({
  selector: 'linear-legends',
  templateUrl: './linear-legends.component.html',
  styleUrl: './linear-legends.component.css',
  standalone: false
})
export class LinearLegendsComponent {
  @Input() type: string;
}
